(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('AuditsService', AuditsService);

  AuditsService.$inject = ['$resource', 'API_URI'];

  function AuditsService($resource, API_URI) {
    return $resource(API_URI + 'management/jhipster/audits/:id', {}, {
      'get': {
        method: 'GET',
        isArray: true
      },
      'query': {
        method: 'GET',
        isArray: true,
        params: {fromDate: null, toDate: null}
      }
    });
  }
})();
